import BrowserNavigation from './BrowserNavigation';

export default BrowserNavigation;
